/**
 * Run `callback` once at the start of every wall-clock minute (i.e. on the :00
 * second), rather than at a page-load-relative offset. The first call fires at
 * the next minute boundary, then every 60s after that.
 *
 * Useful for live polling that should land just as fixtures tick over to a new
 * match minute. Returns a cleanup function that cancels the pending alignment
 * timeout and the running interval.
 */
export const setMinuteAlignedInterval = (callback) => {
    let intervalId;
    const msToNextMinute = 60000 - (Date.now() % 60000);
    const timeoutId = window.setTimeout(() => {
        callback();
        intervalId = window.setInterval(callback, 60000);
    }, msToNextMinute);

    return () => {
        window.clearTimeout(timeoutId);
        window.clearInterval(intervalId);
    };
};
